import React from 'react';
import classNames from 'classnames';
import annotationIcon from '../../icons/non-prefilled/16x16/annotation.svg';
import SVGIcon from '../../components/SVGIcon';
import * as styles from './AnnotationIcon.module.scss';

interface AnnotationIconContainerProps {
  children: React.ReactNode;
  hoverable?: boolean;
}

export const AnnotationIconContainer = ({
  children,
  hoverable,
}: AnnotationIconContainerProps) => (
  <div
    className={classNames(styles.container, {
      [styles.hoverable]: hoverable,
    })}
  >
    {children}
  </div>
);

const AnnotationIcon = (props: React.ComponentProps<typeof SVGIcon>) => (
  <SVGIcon {...props} className={classNames(styles.icon, props.className)}>
    {annotationIcon}
  </SVGIcon>
);

export default AnnotationIcon;
